import { useEffect } from 'react';

/** DOM mount for portaled overlays (sheets, modals). Sits above app chrome. */
export const OVERLAY_ROOT_ID = 'overlay-root';

export function getOverlayRoot(): HTMLElement {
  if (typeof document === 'undefined') {
    throw new Error('getOverlayRoot() requires a browser environment');
  }
  const el = document.getElementById(OVERLAY_ROOT_ID);
  if (!el) throw new Error(`Missing #${OVERLAY_ROOT_ID} in index.html`);
  return el;
}

/** Hide persistent chrome (tab bar) while any overlay is open. Ref-counted. */
let overlayLockCount = 0;

export function lockAppChrome(): () => void {
  overlayLockCount += 1;
  document.documentElement.dataset.overlay = 'open';
  return () => {
    overlayLockCount = Math.max(0, overlayLockCount - 1);
    if (overlayLockCount === 0) delete document.documentElement.dataset.overlay;
  };
}

/** Keep the tab bar hidden until a portaled sheet has fully dismissed — not just
 *  when `open` flips false (that runs before AnimatePresence finishes the slide). */
export function useOverlayChromeLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    return lockAppChrome();
  }, [locked]);
}
